<template>
  <div id="projectStatistics">
    <!-- 第一行 -->
    <ul class="numberHeadre">
      <li>
        <p class="number">14 天</p>
        <p class="headerName">累计工时</p>
      </li>
      <li>
        <p class="number">三级审核</p>
        <p class="headerName">当前进度</p>
      </li>
      <li>
        <p class="number">现场调查</p>
        <p class="headerName">耗时最高阶段</p>
      </li>
      <li>
        <p class="number">10%</p>
        <p class="headerName">延误率</p>
      </li>
    </ul>
    <!-- 第二行 -->
    <div class="taskContainer">
      <!-- 标题 -->
      <div class="titleRow">
        <h3>项目</h3>
        <el-button>导出</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{background:'#40A0F2', padding:'17px 0',color:'#fff',fontSize:'16px',fontWeight:'400'}"
        :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
        :data="tableData"
        stripe
        height="calc(100% - 70px)"
        style="width: 100%; margin-top:20px"
      >
        <el-table-column prop="id" :show-overflow-tooltip="true" align="center" label="阶段"></el-table-column>
        <el-table-column
          prop="customer_name"
          :show-overflow-tooltip="true"
          align="center"
          label="计划工时"
        ></el-table-column>
        <el-table-column
          prop="customer_name"
          :show-overflow-tooltip="true"
          align="center"
          label="实际完成工时"
        ></el-table-column>
        <el-table-column
          prop="customer_name"
          :show-overflow-tooltip="true"
          align="center"
          label="延误时间"
        ></el-table-column>
        <el-table-column
          prop="customer_name"
          :show-overflow-tooltip="true"
          align="center"
          label="延误率"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 第三行 -->
    <div class="echartsRow">
      <div class="leftEcharts" ref="Settled"></div>
      <div class="rightEcharts" ref="Settled2"></div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  data() {
    return {
      tableData: [
        {
          id: 1,
          customer_name: 'xxxx',
        },
        {
          id: 1,
          customer_name: 'xxxx',
        },
        {
          id: 1,
          customer_name: 'xxxx',
        },
        {
          id: 1,
          customer_name: 'xxxx',
        },
        {
          id: 1,
          customer_name: 'xxxx',
        },
        {
          id: 1,
          customer_name: 'xxxx',
        },
      ],
      myChart1: {},
      myChart2: {},
      options1: {
        title: {
          text: '任务进度统计',
          top: '20',
          left: '30',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'item',
        },
        cache_department_id: '',

        series: [
          {
            name: '访问来源',
            type: 'pie',
            // radius: '50%',
            radius: ['40%', '70%'],
            data: [
              { value: 484, name: '延误' },
              { value: 300, name: '守时' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
      options2: {
        title: {
          text: '任务阶段时间统计',
          top: '20',
          left: '30',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
          },
        ],
      },
    }
  },
  methods: {
    SettledLine1() {
      let Settled = this.$echarts.init(this.$refs.Settled)
      this.myChart1 = Settled
      // 绘制已结算图表
      Settled.setOption(this.options1)
    },
    SettledLine2() {
      let Settled = this.$echarts.init(this.$refs.Settled2)
      this.myChart2 = Settled
      // 绘制已结算图表
      Settled.setOption(this.options2)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
  },
  mounted() {
    this.SettledLine1()
    this.SettledLine2()
    window.onresize = () => {
      this.$nextTick(() => {
        this.myChart1.resize()
        this.myChart2.resize()
      })
    }
  },
}
</script>
<style lang="less" scoped>
#projectStatistics {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 30px;
  .numberHeadre {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    li {
      box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
      border-radius: 10px;
      width: 24%;
      height: 85px;
      background-image: linear-gradient(to right, #46e0d6, #1099d1);
      display: flex;
      flex-direction: column;
      align-items: center;
      .number {
        margin-top: 15px;
        font-size: 22px;
        color: #fff;
      }
      .headerName {
        font-size: 18px;
        color: #fff;
      }
    }
    li:nth-child(2) {
      background-image: linear-gradient(to right, #9270ff, #fd5d9f);
    }
    li:nth-child(3) {
      background-image: linear-gradient(to right, #f8cf8b, #f35969);
    }
    li:nth-child(4) {
      background-image: linear-gradient(to right, #764ffd, #a7cdfe);
    }
  }
  .taskContainer {
    width: 100%;
    height: 50%;
    box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    padding: 30px;
    padding-top: 20px;
    padding-bottom: 19px;
    .titleRow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        color: #333;
        font-size: 22px;
        font-weight: normal;
      }
      /deep/ .el-button {
        width: 130px;
        height: 45px;
        font-size: 18px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: #40a0f2;
        border-radius: 24px;
        color: #fff;
      }
    }
  }
  .echartsRow {
    margin-top: 20px;
    height: calc(50% - 85px - 20px - 20px);
    display: flex;

    .leftEcharts {
      width: 40%;
      height: 100%;
      margin-right: 1.5%;
      background-color: #fff;
      box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
      border-radius: 10px;
    }
    .rightEcharts {
      width: 58.5%;
      height: 100%;
      background-color: #fff;
      box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
      border-radius: 10px;
    }
  }
}

// 修改表格样式
// 表格行
/deep/.el-table__body {
  width: 100% !important;
}
.el-table::before {
  display: none;
}
/deep/.el-table td.gutter,
/deep/.el-table th.gutter {
  background-color: rgb(64, 160, 242);
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border-bottom: 1px solid rgb(64, 160, 242);
}
/deep/.el-table__body-wrapper {
  box-sizing: border-box;
  border: 1px solid #f4f5f6;
  border-bottom: none;
  border-top: 1px solid rgb(64, 160, 242);
}
/deep/.el-table {
  border-bottom: 1px solid #f4f5f6;
}
// 鼠标经过效果
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #eff8ff;
}
// 斑马颜色
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f4f5f6;
}
// 滚动条的宽度
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  // position: absolute;
  // bottom: 0;
  width: 6px; // 横向滚动条
  height: 5px; // 纵向滚动条 必写
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}
</style>
